/**
 * セッション整合性用: GET /api/me を no-store で取得し、認証済みかどうかを返す。
 * 同一タスク内の並行呼び出しは 1 リクエストにまとめる。
 */
export const AUTH_SESSION_REVALIDATE_EVENT = 'auth:session-revalidate';

let inFlight: Promise<boolean> | null = null;

export function requestAuthSessionRevalidate(): void {
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_REVALIDATE_EVENT));
}

export async function fetchMeIsAuthenticated(): Promise<boolean> {
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch('/api/me', {
        credentials: 'include',
        cache: 'no-store',
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      if (!response.ok) return false;

      const data = (await response.json().catch(() => ({}))) as { authenticated?: boolean };
      return data?.authenticated === true;
    } catch {
      return false;
    } finally {
      inFlight = null;
    }
  })();

  return inFlight;
}
